import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const EligibleStudentsQuery = graphql.persisted(
  "EligibleStudentsQuery",
  graphql(`
    query EligibleStudentsQuery($schoolYearId: ID!) {
      schoolYear(id: $schoolYearId) {
        id
        studentEnrollments {
          id
          person {
            id
            firstName
            lastName
          }
          gradeLevel
          state
        }
      }
    }
  `)
);

export { EligibleStudentsQuery };

export function useEligibleStudentsQuery(schoolYearId?: string) {
  return useQuery(EligibleStudentsQuery, {
    variables: { schoolYearId: schoolYearId! },
    skip: !schoolYearId,
  });
}
